import { ButtonDesignTokens } from '@primeuix/themes/types/button';

import {
  getColor,
  getFontWeight,
  getRem,
} from '@customer-portal/shared/helpers/theme-utils';

export const buttonOverride: ButtonDesignTokens = {
  root: {
    borderRadius: getRem(10),
    gap: getRem(8),
    paddingX: getRem(16),
    paddingY: getRem(8),
    label: {
      fontWeight: getFontWeight('semibold'),
    },
    focusRing: {
      width: '0',
      style: 'none',
      offset: '0',
    },
    lg: {
      paddingX: getRem(16),
      paddingY: getRem(8),
    },
  },
  colorScheme: {
    light: {
      outlined: {
        primary: {
          color: getColor('SeaBlue'),
          borderColor: getColor('SeaBlue'),
        },
      },
    },
  },
};
